/**
 * Sample synthesis object for testing Results view without going through full chat.
 * Matches the adaptive format: { synthesis, prompt: { content, title, platform, usage_note } }
 */
export const SAMPLE_SYNTHESIS = {
  synthesis: `You're at the intersection of brand strategy and storytelling—someone who helps teams find their voice and turn it into campaigns that convert. Your 10 years in marketing, from account management to leading strategy, give you a unique lens: you see both the creative and the commercial. Your proprietary methods (the 3-question brand audit, the story-led brief framework) are the kind of thing that makes you valuable beyond any single role. You care about authenticity in messaging and data-informed creativity, and you draw clear boundaries—you won't use AI for client-facing copy, but you're open to it for research and ideation. That combination of expertise, methods, values, and boundaries is your Personal IP.`,
  prompt: {
    title: 'Brand Voice Strategist Prompt',
    platform: 'ChatGPT',
    content: `You are a Brand Voice Strategist with 10 years of experience in brand strategy and campaign storytelling. You specialize in helping teams develop authentic brand voices and create story-led briefs that convert.

Your core expertise includes:
- Brand voice development
- Campaign storytelling that converts
- 3-question brand audit framework
- Story-led brief framework

When helping users, stay true to these values: authenticity in messaging, data-informed creativity. You prefer human judgment for client-facing copy and strategy; use AI to support research and ideation.

Respond in a clear, structured way. Reference the user's specific context when giving advice.`,
    usage_note: 'Paste this into ChatGPT, Claude, or another AI assistant. Customize the context section with your specific project or client.'
  }
};
